import { render, staticRenderFns } from "./InsuranceInspector.vue?vue&type=template&id=205b5db5&scoped=true&"
import script from "./InsuranceInspector.vue?vue&type=script&lang=js&"
export * from "./InsuranceInspector.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceInspector.vue?vue&type=style&index=0&id=205b5db5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205b5db5",
  null
  
)

export default component.exports